import { CategoryKey } from 'config/categories';
import { productParamsById, productsByCategory } from 'config/products';
import { SelectableProduct } from 'types/selectable-product';

const DEFAULT_FALLBACK_LIMIT = 8;

export function getStaticProductsForCategory(category: CategoryKey): SelectableProduct[] {
  return productsByCategory[category].map((id) => ({
    id,
    ...productParamsById[id],
  }));
}

export function getStaticFallbackProducts(limit = DEFAULT_FALLBACK_LIMIT): SelectableProduct[] {
  return productsByCategory[CategoryKey.BestSellers].slice(0, limit).map((id) => ({
    id,
    ...productParamsById[id],
  }));
}
